import appConfig from '../../../config';

const { hostUrl, apiUrl } = appConfig;
const apiV1Url: string = apiUrl();
const apiV2Url: string = apiUrl(2);
export default {
  tokenUrl: (): string => `${hostUrl}/connect/token`,
  signUpUrl: (): string => `${apiV1Url}/Accounts/sign-up`,
  verifyAccountUrl: (): string => `${apiV1Url}/Accounts/verify-email`,
  verifyNewEmailUrl: (): string => `${apiV1Url}/Accounts/verify-new-email`,
  forgotPasswordUrl: (): string => `${apiV1Url}/Accounts/forgot-password`,
  forgotPasswordOtpUrl: (): string => `${apiV1Url}/Accounts/forgot-password-otp`,
  resetPasswordOtpUrl: (): string => `${apiV1Url}/Accounts/reset-password-otp`,
  resendPasswordOtpUrl: (): string => `${apiV1Url}/Accounts/resend-password-otp`,
  confirmAccountOtpUrl: (): string => `${apiV2Url}/Accounts/confirm-account-otp`,
  resendAccountOtpUrl: (): string => `${apiV2Url}/Accounts/resend-account-otp`,
  resetPasswordUrl: (): string => `${apiV1Url}/Accounts/reset-password`,
  unlockAccountUrl: (): string => `${apiUrl()}/users/unlock_account`,
  initialPasswordUrl: (): string => `${apiV1Url}/Accounts/validate-initial-sign-up`,
  canSignUpUrl: (): string => `${apiV1Url}/Accounts/can-sign-up`,
  signUpV2: (): string => `${apiV2Url}/Accounts/sign-up`,
  facebookExternalSignIn: (): string => `${apiV1Url}/Accounts/facebook-external-sign-in`,
  googleExternalSignIn: (): string => `${apiV1Url}/Accounts/google-external-sign-in`,
  appleExternalSignIn: (): string => `${apiV1Url}/Accounts/apple-external-sign-in`,
};
